/**
 * Read a single cookie value by name. Pure function — accepts the cookie
 * string explicitly to stay testable without DOM globals.
 *
 * @param {string} name
 * @param {string} [cookieString] defaults to document.cookie at call time
 * @returns {string | null}
 */
export function readCookie(name, cookieString = document.cookie) {
  if (!cookieString) return null;
  for (const pair of cookieString.split(';')) {
    const [rawKey, ...rawValue] = pair.split('=');
    if (rawKey.trim() === name) {
      return rawValue.join('=').trim();
    }
  }
  return null;
}
